import React from 'react';
// import './FourthSection.css';
import { Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import logo from '../../Raya logo/CuraHelden-Logo (1).png'
import cover from '../../Raya logo/CuraHelden-Logo (1).png'
const Curahelden = () => {

    const navigate = useNavigate();
    const transferToPage = () => {
        // navigate('/Novus');

        window.open('https://curahelden.de/')
    }
    return (
        <div className='main-first-section'>
            <Container maxWidth="xl">
                <div className='content'>
                      <div>
                        <img src={cover} alt="mobile image not found" className='mainImage' />
                    </div> 
                    <div className='text-container novusLabPart' style={{ width: '100%' , }}>
                        {/* <img className='novuslab_image'  src={logo} alt='novus-lab not found' /> */}
                        <h1 style={{ marginBottom: '0px' }} >International Healthcare Recruitment</h1>
                        <h3 style={{ marginTop: '0px' }}>Connecting care heroes with Germany’s healthcare system.</h3>
                        <ArrowForwardIcon onClick={transferToPage} style={{ fontSize: '22px', border: '1px solid #000', borderRadius: '50%', padding: '4px', cursor: 'pointer' }} />
                    </div>
                   

                </div>
            </Container>
        </div>
    );
}

export default Curahelden;
